RivalIQ.apps.Site.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.PasswordReset = Marionette.View.extend({
        ui: {
            email: `[name='email']`,
            csrfToken: `[name='_csrf']`,
            setPasswordBtn: '.x-set-password',
            sendPasswordBtn: '.x-send-reset',
            password: `[name='password']`,
            passwordConfirmation: `[name='password_confirmation']`,
            validationErrors: '.x-validation-msg',
            global: '.x-global'
        },
        events: {
            'click @ui.sendPasswordBtn': 'onSendClicked',
            'click @ui.setPasswordBtn': 'onSetPassword',
            'keypress #email_input': 'onKeypressed',
            'keypress #password_confirmation': 'onKeypressed'
        },
        onSendClicked: function () {

            const me = this;
            me.ui.validationErrors.hide();

            let emailAddress = $('#email_input').val();
            emailAddress = emailAddress.toLowerCase();
            const csrfToken = $('#_csrf').val();

            if (!emailAddress) {
                return me.showError(me.ui.email, 'Email is required');
            } else {
                me.ui.sendPasswordBtn.button('loading');
                $('#errorText').html('Trying to send password...');

                setTimeout(_.bind(me.submit, me, emailAddress, csrfToken), 1000);
            }
        },
        onSetPassword: function () {
            const me = this;

            me.ui.validationErrors.hide();
            me.ui.setPasswordBtn.button('loading');
            const password = me.ui.password.val();
            const csrfToken = me.ui.csrfToken.val();

            if (!password) {
                return me.showPasswordError(me.ui.password, 'Password is required');
            }
            if (password !== me.ui.passwordConfirmation.val()) {
                return me.showPasswordError(me.ui.passwordConfirmation, 'Confirmation does not match password');
            }

            $.ajax({
                type: 'PUT',
                data: {
                    password: password,
                    _csrf: csrfToken
                },
                url: '/api/users/password/reset',
                error: function (xhr) {
                    if (xhr.errorName === 'InvalidLoginTokenError') {
                        return me.showPasswordError(me.ui.global, `Try resetting your password again. Looks like you're using an old token.`);
                    }
                    if (xhr.errorName === 'WeakPasswordError') {
                        return me.showPasswordError(me.ui.password, 'Password must be at least 8 characters');
                    }

                    me.showPasswordError(me.ui.global, 'An error occurred, please try again');
                },
                success: function () {
                    window.location = '/overview';
                }
            });
        },
        showError: function (ui, error) {
            ui.siblings('.x-validation-msg').show().find('.text-danger').text(error);
        },
        showPasswordError: function (ui, error) {
            const me = this;
            me.ui.setPasswordBtn.button('reset');
            me.showError(ui, error);
        },
        onKeypressed: function (e) {
            const me = this;

            if (e.which === 13) {
                if (e.target.id === 'email_input') {
                    me.onSendClicked();
                } else if (e.target.id === 'password_confirmation') {
                    me.onSetPassword();
                }
            }
        },
        render: function () {

            const me = this;
            $('#email_input').focus();
            return me;
        },
        submit: function (emailAddress, csrfToken) {
            const me = this;

            $.ajax({
                type: 'POST',
                url: '/api/users/password/reset',
                data: {
                    email: emailAddress,
                    _csrf: csrfToken
                },
                error: function () {
                    $('#errorText').html(`That isn't a valid email, or we don't know about you.  Try again.`);
                    me.ui.sendPasswordBtn.button('reset');
                },
                success: function () {
                    $('#errorText').html('Success! Check your email for a reset link.');
                    $('#goLogin').show();
                    me.ui.sendPasswordBtn.button('reset');
                }
            });
        },

        initialize: function () {
            const me = this;
            me.bindUIElements();
        }
    });

});
